import { createAction } from 'redux-act';

import { IBaseRequestParams } from '../types/Request.types';

import { IDetectedCountry } from './geoIpCountry.types';

const PREFIX = 'GEO_IP_COUNTRY';

export const detectCountryRequest = createAction<IBaseRequestParams>(`${PREFIX}/DETECT_REQUEST`);
export const detectCountrySuccess = createAction<IDetectedCountry>(`${PREFIX}/DETECT_SUCCESS`);
export const detectCountryFail = createAction(`${PREFIX}/DETECT_FAIL`);

export const skipDetectCountryFlow = createAction(`${PREFIX}/SKIP_DETECT_COUNTRY_FLOW`);
